<template>
    <div class="certifications">
        <h1>Mes Certifications</h1>
        <div class="certifications-grid">
            <div class="certification-card rgpd-card">
                <div class="certification-content">
                    <h3>MOOC RGPD</h3>
                    <p class="certification-date">2023</p>
                    <p class="certification-desc">Formation sur la protection des données personnelles et le RGPD</p>
                    <div class="certification-tags">
                        <span>RGPD</span>
                        <span>Protection des données</span>
                        <span>Conformité</span>
                    </div>
                    <div class="modules-list">
                        <div class="module-item">
                            <span class="module-title">Module 1 : Le RGPD et ses notions clés</span>
                            <a href="/certifications/mooc-rgpd-module1.pdf" target="_blank" class="download-btn">
                                <i class="fas fa-download"></i> Afficher
                            </a>
                        </div>
                        <div class="module-item">
                            <span class="module-title">Module 2 : Les principes de la protection des données</span>
                            <a href="/certifications/mooc-rgpd-module2.pdf" target="_blank" class="download-btn">
                                <i class="fas fa-download"></i> Afficher
                            </a>
                        </div>
                        <div class="module-item">
                            <span class="module-title">Module 3 : Les responsabilités des acteurs</span>
                            <a href="/certifications/mooc-rgpd-module3.pdf" target="_blank" class="download-btn">
                                <i class="fas fa-download"></i> Afficher
                            </a>
                        </div>
                        <div class="module-item">
                            <span class="module-title">Module 4 : Le DPO et les outils de conformité</span>
                            <a href="/certifications/mooc-rgpd-module4.pdf" target="_blank" class="download-btn">
                                <i class="fas fa-download"></i> Afficher
                            </a>
                        </div>
                        <div class="module-item">
                            <span class="module-title">Module 5 : Les collectivités territoriales</span>
                            <a href="/certifications/mooc-rgpd-module5.pdf" target="_blank" class="download-btn">
                                <i class="fas fa-download"></i> Afficher
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="certification-card">
                <div class="certification-content">
                    <h3>MOOC ANSSI</h3>
                    <p class="certification-date">2023</p>
                    <p class="certification-desc">Formation sur la cybersécurité et les bonnes pratiques</p>
                    <div class="certification-tags">
                        <span>Cybersécurité</span>
                        <span>ANSSI</span>
                        <span>Sécurité</span>
                    </div>
                    <div class="modules-list">
                        <div class="module-item">
                            <span class="module-title">Certification MOOC ANSSI</span>
                            <a href="/certifications/mooc-anssi.pdf" target="_blank" class="download-btn">
                                <i class="fas fa-download"></i> Afficher
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="certification-card">
                <div class="certification-content">
                    <h3>PIX</h3>
                    <p class="certification-date">2024</p>
                    <p class="certification-desc">Certification des compétences numériques</p>
                    <div class="certification-tags">
                        <span>Compétences Numériques</span>
                        <span>PIX</span>
                        <span>Digital</span>
                    </div>
                    <div class="modules-list">
                        <div class="module-item">
                            <span class="module-title">Attestation PIX</span>
                            <a href="/certifications/attestation-pix.pdf" target="_blank" class="download-btn">
                                <i class="fas fa-download"></i> Afficher
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="certification-card">
                <div class="certification-content">
                    <h3>Cisco Netacad</h3>
                    <p class="certification-date">2024</p>
                    <p class="certification-desc">Formation Introduction à la Cybersécurité</p>
                    <div class="certification-tags">
                        <span>Cybersécurité</span>
                        <span>Cisco</span>
                        <span>Netacad</span>
                    </div>
                    <div class="modules-list">
                        <div class="module-item">
                            <span class="module-title">Introduction à la Cybersécurité</span>
                            <a href="/certifications/netacad-cybersecurity.pdf" target="_blank" class="download-btn">
                                <i class="fas fa-download"></i> EN COURS
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="rootme-section">
            <div class="certification-card rootme-card">
                <div class="certification-content">
                    <h3>RootMe</h3>
                    <p class="certification-date">2024</p>
                    <p class="certification-desc">Plateforme d'apprentissage de la cybersécurité</p>
                    <div class="certification-tags">
                        <span>CTF</span>
                        <span>Cybersécurité</span>
                        <span>Pentest</span>
                    </div>

                    <div class="challenges-grid">
                        <div class="challenge-category">
                            <h4>Web - Client</h4>
                            <div class="challenges-list">
                                <div class="challenge-item">
                                    <span class="challenge-title">Javascript - Authentification</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Client/Javascript-Authentification"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Javascript - Source</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Client/Javascript-Source"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Javascript - Authentification 2</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Client/Javascript-Authentification-2"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Javascript - Obfuscation 2</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Client/Javascript-Obfuscation-2"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Javascript - Obfuscation 3</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Client/Javascript-Obfuscation-3"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">XSS stockée 1</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Client/XSS-Stockee-1"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">CSRF - 0 protection</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Client/CSRF-0-protection"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="challenge-category">
                            <h4>Cryptanalyse</h4>
                            <div class="challenges-list">
                                <div class="challenge-item">
                                    <span class="challenge-title">Encodage - ASCII</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Cryptanalyse/Encodage-ASCII"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Encodage - UU</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Cryptanalyse/Encodage-UU"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Hash - Message Digest 5</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Cryptanalyse/Hash-Message-Digest-5"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Hash - SHA-2</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Cryptanalyse/Hash-SHA-2"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Chiffrement par décalage</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Cryptanalyse/Chiffrement-par-decalage"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="challenge-category">
                            <h4>Réseau</h4>
                            <div class="challenges-list">
                                <div class="challenge-item">
                                    <span class="challenge-title">FTP - Authentification</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Reseau/FTP-Authentification"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">TELNET - authentification</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Reseau/TELNET-authentification"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">ETHERNET - trame</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Reseau/ETHERNET-trame"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">CISCO - mot de passe</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Reseau/CISCO-mot-de-passe"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">IP - Time To Live</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Reseau/IP-Time-To-Live"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Bluetooth - Fichier inconnu</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Reseau/Bluetooth-Fichier-inconnu"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Authentification twitter</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Reseau/Authentification-twitter"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="challenge-category">
                            <h4>Web - Serveur</h4>
                            <div class="challenges-list">
                                <div class="challenge-item">
                                    <span class="challenge-title">HTML - Code source</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Serveur/HTML-Code-source"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">HTTP - User-agent</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Serveur/HTTP-User-agent"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">Mot de passe faible</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Serveur/Mot-de-passe-faible"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">HTTP - Directory indexing</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Serveur/HTTP-Directory-indexing"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">SQL injection - Authentification</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Serveur/SQL-injection-authentification"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">HTTP - POST</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Serveur/HTTP-POST"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">HTTP - Contournement de filtrage IP</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Serveur/HTTP-Contournement-de-filtrage-IP"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">HTTP - Open redirect</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Web-Serveur/HTTP-Open-redirect"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="challenge-category">
                            <h4>Programmation</h4>
                            <div class="challenges-list">
                                <div class="challenge-item">
                                    <span class="challenge-title">TCP - La roue romaine</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Programmation/TCP-La-roue-romaine"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                                <div class="challenge-item">
                                    <span class="challenge-title">TCP - Chaîne encodée</span>
                                    <a href="https://www.root-me.org/fr/Challenges/Programmation/TCP-Chaine-encodee"
                                        target="_blank" class="challenge-link">
                                        <i class="fas fa-external-link-alt"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CertificationsPage'
}
</script>

<style scoped>
.certifications {
    color: white;
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
}

h1 {
    text-align: center;
    color: #2196F3;
    margin-bottom: 2rem;
    font-size: 2.5rem;
}

.certifications-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    margin-bottom: 2rem;
}

.certification-card {
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid #2196F3;
    border-radius: 10px;
    padding: 1.5rem;
    backdrop-filter: blur(5px);
    transition: all 0.3s ease;
}

.certification-card:hover {
    transform: translateY(-5px);
    border-color: #64B5F6;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.certification-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.certification-content h3 {
    color: #64B5F6;
    margin: 0;
    font-size: 1.5rem;
}

.certification-date {
    color: #B0BEC5;
    font-size: 0.9rem;
    margin: 0;
}

.certification-desc {
    color: #B0BEC5;
    margin: 0;
    line-height: 1.4;
}

.certification-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.certification-tags span {
    background: rgba(33, 150, 243, 0.1);
    color: #64B5F6;
    padding: 0.2rem 0.8rem;
    border-radius: 15px;
    font-size: 0.9rem;
    border: 1px solid #2196F3;
}

.download-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: #2196F3;
    color: white;
    padding: 0.8rem 1.5rem;
    border-radius: 5px;
    text-decoration: none;
    margin-top: 1rem;
    transition: all 0.3s ease;
}

.download-btn:hover {
    background: #64B5F6;
    transform: translateY(-2px);
}

.modules-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
}

.module-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(33, 150, 243, 0.1);
    padding: 0.8rem;
    border-radius: 5px;
    border: 1px solid #2196F3;
}

.module-title {
    color: #B0BEC5;
    font-size: 0.9rem;
}

.module-item .download-btn {
    margin: 0;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .certifications {
        padding: 1rem;
    }

    .certifications-grid {
        grid-template-columns: 1fr;
    }

    .rootme-section {
        padding: 0;
    }

    .challenges-grid {
        grid-template-columns: 1fr;
    }
}

.rgpd-card {
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid #2196F3;
    border-radius: 10px;
    padding: 1.5rem;
    backdrop-filter: blur(5px);
    transition: all 0.3s ease;
}

.rgpd-card:hover {
    transform: translateY(-5px);
    border-color: #64B5F6;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.rgpd-card .certification-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.rootme-section {
    width: 96%;
    padding: 0 calc((100% - (200% + 2rem)) / 2);
    box-sizing: border-box;
}

.rootme-card {
    width: 100%;
}

.challenges-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
    margin-top: 1rem;
}

.challenge-category {
    background: rgba(33, 150, 243, 0.1);
    border: 1px solid #2196F3;
    border-radius: 8px;
    padding: 1.25rem;
}

.challenge-category h4 {
    color: #64B5F6;
    margin: 0 0 1rem 0;
    font-size: 1.2rem;
}

.challenges-list {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
}

.challenge-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
    padding: 0.8rem;
    border-radius: 5px;
    border: 1px solid #2196F3;
}

.challenge-title {
    color: #B0BEC5;
    font-size: 0.9rem;
}

.challenge-link {
    color: #64B5F6;
    text-decoration: none;
    transition: all 0.3s ease;
}

.challenge-link:hover {
    color: #2196F3;
    transform: translateY(-2px);
}

@media (max-width: 1200px) {
    .challenges-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
